import React, { useRef } from "react";
import * as PropTypes from "prop-types";
import CurrentSpendingChart from "./CurrentSpendingChart";
import DataViewerFrame from "../../widgets/DataViewerFrame";

const CurrentSpendingChartWidget = props => {
  const ref = useRef();

  return (
    <DataViewerFrame
      dataViewerId="current_spending_chart"
      reference="Figure 1.2"
      title="Current Spending"
      subtitle="Comparison by GNI Group and Sector"
      contentWidth={464}
      chartRef={ref}
    >
      <CurrentSpendingChart ref={ref} data={props.data} />
    </DataViewerFrame>
  );
};

CurrentSpendingChartWidget.propTypes = {
  data: PropTypes.array.isRequired
};

export default CurrentSpendingChartWidget;
